import { Typography } from '@mui/material'
import { AppHeader } from '@/components/app-header'

type ComingSoonProps = {
  title: string
}

export function ComingSoon({ title }: ComingSoonProps) {
  return (
    <>
      <AppHeader />
      <Typography variant="h5">{title}</Typography>
      <Typography color="text.secondary" mt={1}>
        Em breve
      </Typography>
    </>
  )
}
